import PrepressSortTable from "./PrepressSortTable";
import PrepressExtraCopiesIndex from "./PrepressExtraCopiesIndex";

class PrepressExtraCopiesSortTable extends PrepressSortTable {
  reactTableComponent() {
    return PrepressExtraCopiesIndex;
  }

  showInHouse(provider) {
    const show = [];
    this.data.forEach((order) => {
      if (order.print_providers.includes(provider)) {
        show.push(order);
      }
    });
    return this.getReverseList() ? show.slice().reverse() : show;
  }

  showOutSourced() {
    const show = [];
    const inHouse = [this.inHouseWilmingtonProvider(), this.inHouseDallasProvider()];
    this.data.forEach((order) => {
      // Take the difference of the providers in the order and the in house providers
      if (order.print_providers.filter(provider => !inHouse.includes(provider)).length > 0) {
        show.push(order);
      }
    });
    return this.getReverseList() ? show.slice().reverse() : show;
  }
}

export default PrepressExtraCopiesSortTable;
